export default __webpack_public_path__ + "static/gallery_xl_3-b417f3e905f75973c0b7c7cf5be219c5.jpg";